// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__jhJGw","accordion-group":"accordion_accordion-group__WTDS5","accordion-trigger":"accordion_accordion-trigger__SzvJd"};